/**
 * 基础菜单 大数据
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>首页轮播图</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <!-- <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.deptName" placeholder="输入部门名称"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.deptNo" placeholder="输入部门代码"></el-input>
      </el-form-item> -->
      <el-form-item>
        <!-- <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button> -->
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" :default-sort = "{prop: 'create_time', order: 'descending'}">


      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column sortable prop="image" label="缩略图" width="120" align="center">
        <template slot-scope="scope">
        <div class="demo-image__preview">
          <el-image
            style="width: 100px; height: 100px"
            :src="scope.row.image"
            :preview-src-list="[scope.row.image]">
          </el-image>
        </div>
        </template>
      </el-table-column>
        <el-table-column sortable label="类型" align="center" width="100">
            <template slot-scope="scope">
                <div v-if="scope.row.type == 'link' || scope.row.type == undefined">链接</div>
                <div v-if="scope.row.type == 'video'">视频</div>
                <div v-if="scope.row.type == 'brand'">品牌</div>
            </template>
        </el-table-column>
      <el-table-column sortable prop="sort" label="排序" align="center" width="100">
      </el-table-column>
        <el-table-column label="链接内容" prop="content"></el-table-column>
     <!-- <el-table-column sortable prop="content" label="简介" width="400">
      </el-table-column>


      <el-table-column sortable prop="create_time" label="修改时间" width="200">
      </el-table-column> -->
      <el-table-column align="center" label="操作" fixed="right" min-width="120">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)" class="mobile-delete">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog" class="mobile-dialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="缩略图" prop="image">
          <template slot-scope="scope">
            <el-upload
              class="avatar-uploader"
              :action="baseUrl+'/api/user/uploads'"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload">
              <img v-if="editForm.image" :src="editForm.image" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
           </template>
        </el-form-item>
          <el-form-item label="类型" prop="type">
            <el-select size="small" placeholder="请选择类型" v-model="editForm.type">
                <el-option label="链接" value="link"></el-option>
                <el-option label="视频" value="video"></el-option>
                <el-option label="品牌" value="brand"></el-option>
            </el-select>
          </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input @input="awdojo()" size="small" v-model="editForm.sort" auto-complete="off" placeholder="排序"></el-input>
        </el-form-item>

          <el-form-item label="链接内容">
              <!-- 普通链接 -->
              <el-input size="small" v-model="editForm.content" auto-complete="off" placeholder="链接内容"></el-input>
              <!-- 上传视频 -->
              <el-upload
                  class="upload-demo"
                  :action="baseUrl + '/api/slideshow/uploads'"
                  :show-file-list="false"
                  :on-success="handleVideoSuccess"
                  :before-upload="beforeVideoUpload"
                  v-if="editForm.type == 'video'"
                  >
                  <el-button type="primary" size="mini">上传视频</el-button>
                  <template #tip>
                      <div class="el-upload__tip">
                          视频类型mp4，大小不超过20m
                      </div>
                  </template>
              </el-upload>
              <!-- 跳转品牌 -->
              <el-select v-model="editForm.content" filterable  placeholder="请选择" style="margin-top: 20px;" v-if="editForm.type == 'brand'">
                  <el-option
                      v-for="item in brand_list"
                      :key="item._id.$oid"
                      :label="item.name"
                      :value="item._id.$oid">
                  </el-option>
              </el-select>
          </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {slide, slideSave, slideDelete, sortlist, brandlist} from '../../api/userMG'
import Pagination from '../../components/Pagination'
import Tinymce from "@/components/Tinymce";
export default {

  data() {
    return {
      baseUrl : "",
      brandListData:{},//分类列表
        brand_list: [],
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {
        token: localStorage.getItem('logintoken'),
        image : '',
        image1 : '',
        sort :'',
        // 链接类型
        type : 'link',
        // 链接内容
        content: '',
        video: '',
        video1: '',
      },
      // rules表单验证
      rules: {
          type: [
              { require: true, message: '类型', trigger: 'blur' }
          ],
        sort: [
          { required: true, message: '排序', trigger: 'blur' }
        ]
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination,Tinymce
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getSort()
    this.getdata(this.formInline)
    this.baseUrl=this.$config.baseUrl
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {



      handleAvatarSuccess(res, file) {
              this.editForm.image = URL.createObjectURL(file.raw);
              this.editForm.image1=res
              this.$message.success("上传成功");
              this.$forceUpdate()
           },
       beforeAvatarUpload(file) {
         const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';

         if (!isJPG) {
           this.$message.error('上传头像图片只能是 JPG或者PNG 格式!');
          return isJPG ;
         }
         else{
           this.$message.warning("上传中");

           return isJPG ;
         }
       },
      handleVideoSuccess(res, file) {
          this.editForm.video = URL.createObjectURL(file.raw);
          this.editForm.content=res
          this.$message.success("上传成功");
          this.$forceUpdate()
          // console.log(this.editForm);
      },
      beforeVideoUpload(file) {
          const isVideo = file.type === 'video/mp4';

          if (!isVideo) {
              this.$message.error('视频类型只支持mp4格式');
              return isVideo ;
          }
          else{
              this.$message.warning("上传中");

              return isVideo ;
          }
      },
      asdw(e){
        console.log(e);
      },
      awdojo(){
        this.$forceUpdate()
      },

      getSort() {
        /***
         * 调用接口，注释上面模拟数据 取消下面注释
         */
        let that = this
        sortlist()
          .then(res => {
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              that.brandListData = res
               // console.log(that.brandListData);
            }
          })
          .catch(err => {
            this.$message.error('菜单加载失败，请稍后再试！')
          })

          brandlist()
              .then(res => {
                  if (res.success == false) {
                      this.$message({
                          type: 'info',
                          message: res.msg
                      })
                  } else {
                      that.brand_list = res
                      console.log(that.brand_list);
                  }
              })
              .catch(err => {
                  this.$message.error('菜单加载失败，请稍后再试！')
              })
      },
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      slide(parameter)
        .then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.count
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.ids = row._id.$oid
        this.editForm.sort = row.sort
        this.editForm.image = row.image
        this.editForm.image1 = row.image1

          this.editForm.type = row.type == undefined ? 'link' : row.type;
        this.editForm.video = row.video;
        this.editForm.content = row.content;
      } else {
        this.title = '添加'
        this.editForm.ids = ''
        this.editForm.sort = ''
        this.editForm.image = ''
        this.editForm.image1 = ''

          this.editForm.type = 'link';
        this.editForm.video = '';
        this.editForm.content = '';
      }
      this.$forceUpdate()
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          slideSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {

          slideDelete(row._id.$oid)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
  .Tinymce_box {
    display: flex;
  }
  .editor-content {
    margin-left: 30px;
    flex-grow: 1;
    border: 2px dashed #f1f1f1;
    padding:0 20px;
  }
  h3 {
    color: #808080;
  }
  .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/slide/slide.vue